class AddressFillFormManager {
    constructor(parent, data) {
        this.parent = parent
        this.data = data
    }

    run() {
        document.querySelectorAll('[data-address-fill-form]').forEach(el => {
            const mAddressFillForm = new AddressFillForm(el, this)
            mAddressFillForm.run()
        })
    }
}

class AddressFillForm {
    constructor(el, parent) {
        this.el = el
        this.parent = parent
    }

    run() {
        this.el.addEventListener('change', (ev) => {
            if (!ev.target.matches('[data-address-fill-form-content]')) {
                return
            }
            this.update()
        })
    }

    update() {
        const information = this.getAllInfo()
        information.forEach(item => {
            this.setField(item.name, item.value)
        })
    }

    getAllInfo() {
        const element = this.el.querySelector('[data-address-fill-form-content]')

        if (!element) {
            return []
        }

        const option = element.querySelector('option:checked')

        if (!option) {
            return []
        }

        return [
            { name: 'first-name', value: option.dataset.firstName || '' },
            { name: 'last-name', value: option.dataset.lastName || '' },
            { name: 'address', value: option.dataset.address || '' },
            { name: 'postal-code', value: option.dataset.postalCode || '' },
            { name: 'city', value: option.dataset.city || '' },
            { name: 'country', value: option.dataset.country || '' },
            { name: 'contact', value: option.dataset.contact || '' },
            { name: 'vat', value: option.dataset.vat || '' }
        ]
    }

    setField(fieldName, value) {
        const field = this.el.querySelector('[data-field="' + fieldName + '"]')

        if (!field) {
            return
        }

        field.value = value

        if ("SELECT" === field.nodeName && -1 === field.selectedIndex) {
            if (!field.dataset.fieldDefault) {
                field.selectedIndex = 0
            } else {
                field.value = field.dataset.fieldDefault
            }
        }

        field.dispatchEvent(new Event('change'))
    }
}

export default AddressFillFormManager